// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__1VE3m","formSpace":"styles_formSpace__19nLP"};